import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateCandidateShiftScheduleFilter } from "@/reducers/clientcandidatedetail";

export const CandidateShiftScheduleTypesList = () => {
  const dispatch = useDispatch();
  const { isPremiumAccount } = useSelector((state) => state.session);
  const { candidateShiftScheduleFilter = { shift_status: "" } } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  useEffect(() => {
    window.onload = () => {
      dispatch(updateCandidateShiftScheduleFilter({ shift_status: "" }));
    };
  });
  const arr = [
    ...(isPremiumAccount
      ? [
          {
            name: "Awaiting Approval",
            cls: "text-yellow bg-yellow-150 hover:bg-yellow-200",
            status: "Applied",
            activeCls: "bg-yellow",
          },
        ]
      : []),
    {
      name: "Booked",
      cls: "text-green bg-green-150 hover:bg-green-200",
      status: "Booked",
      activeCls: "bg-green",
    },
    {
      name: "Availability",
      cls: "text-blue bg-lightblue hover:bg-lightblueBG ",
      status: "Available",
      activeCls: "bg-blue",
    },
  ];
  return (
    <div className="CandidateShiftScheduleTypesList_Wrapper sm:max-lg:grow">
      <div className="flex select-none gap-3">
        {arr.map((item, index) => {
          const { name, cls, status, activeCls } = item;
          return (
            <div
              className={`flex h-[40px] flex-grow items-center gap-2 rounded-lg p-[3px_10px] ${status === candidateShiftScheduleFilter.shift_status ? `text-white ${activeCls}` : cls} cursor-pointer transition-all duration-200 ease-linear`}
              key={index}
              onClick={() => {
                if (candidateShiftScheduleFilter.shift_status === status) {
                  dispatch(
                    updateCandidateShiftScheduleFilter({ shift_status: "" }),
                  );
                } else {
                  dispatch(
                    updateCandidateShiftScheduleFilter({
                      shift_status: status,
                    }),
                  );
                }
              }}
            >
              <p className="m-auto text-center !text-[13px] font-medium leading-[normal] lg:text-[14px]">
                {name}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
